import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CustomFormControlErrorStateMatcher, FormStatus } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { localizationKeys } from '../../constants/localizationKeys';
import { IPasswords } from '../../interfaces/passwords.interface';

export const passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password');
    const repeatedPassword = control.get('repeatedPassword');

    if (password?.pristine || repeatedPassword?.pristine) {
        return null;
    }

    return password && repeatedPassword && password.value === repeatedPassword.value ? null : { passwordMismatch: true };
};

@UntilDestroy()
@Component({
    selector: 'aumico-users-passwords',
    templateUrl: './passwords.component.html',
    styleUrls: ['./passwords.component.scss'],
})
export class PasswordsComponent implements OnInit {
    localizations = localizationKeys;
    readonly password = 'password';
    readonly repeatedPassword = 'repeatedPassword';
    repeatPasswordErrorStateMatcher = new CustomFormControlErrorStateMatcher(['passwordMismatch']);
    passwordChange: string;
    showPasswordConstraints = false;
    public passwordValidatorRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s+]).{8,}$/);

    @Output() passwordFormStatus = new EventEmitter<boolean>();
    @Output() passwordValue = new EventEmitter<IPasswords>();
    @Input() form: UntypedFormGroup;
    ngOnInit(): void {
        this.form.addValidators(passwordMatchValidator);
        this.detectFormStatusChanges();
        this.detectValueChange();
    }

    private detectValueChange(): void {
        this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
            this.passwordChange = value.password;
            this.showPasswordConstraints = true;
        });
    }

    private detectFormStatusChanges(): void {
        this.form.statusChanges.pipe(untilDestroyed(this)).subscribe((status) => {
            const isFormValid = status === FormStatus.VALID;
            this.passwordFormStatus.emit(isFormValid);
            if (status === FormStatus.VALID) {
                this.passwordValue.emit(this.form.value);
            }
        });
    }
}
